import { DetailsChildrenTab, DetailsSectionFiles, type DetailsPageProps } from 'app/main/components/page-layouts';

import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';

import getInvoicesModuleTableColumns from 'app/main/submodules/invoices/InvoicesModuleTableColumns';

import OrdersDetailsTab from './tabs/OrdersDetailsTab';
import OrdersLinesTab from './tabs/OrdersLinesTab';
import OrdersBillingTab from './tabs/OrdersBillingTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <OrdersDetailsTab {...props} />
	},
	{
		id: 'lines',
		title: 'MODULE_ORDERS_LINES_NAME',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, updateRefresh }) => <OrdersLinesTab order={model} updateRefresh={updateRefresh} />
	},
	{
		id: 'billing',
		title: 'MODULE_ORDERS_BILLING_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('orders-billing') || authorizer.cannot('view', 'orders-billing'),
		content: ({ model, updateRefresh }) => <OrdersBillingTab order={model} updateRefresh={updateRefresh} />
	},
	{
		id: 'invoices',
		title: 'MODULE_INVOICES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('invoices') || authorizer.cannot('view', 'invoices'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="invoices_rows"
				content={{ type: 'table', getColumns: getInvoicesModuleTableColumns }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'invc_deleted', filt_clause: 'not_equal', filt_value: 1 },
					{ filt_field: 'inrw_ords_uid', filt_clause: 'equals', filt_value: model.ords_uid }
				]}
			/>
		)
	},
	{
		id: 'docs',
		title: 'MODULE_DOCS_NAME',
		disabled: ({ model, sysSettings, isEdit }) => isEdit || !sysSettings[`docs_${model.core_type}_path`],
		hidden: ({ authorizer, sysSettings }) =>
			sysSettings.docs_enabled !== 'true' ||
			sysSettings.docs_orders_enabled !== 'true' ||
			authorizer.cannot('view', 'docs'),
		content: ({ model, sysSettings }) => (
			<DetailsSectionFiles
				folderPath={`${sysSettings[`docs_${model.core_type}_path`]}\\${model.comp_foldername}\\Ordini\\${model.ords_foldername}`}
			/>
		)
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'oppo_ords_uid', filt_clause: 'equals', filt_value: model.ords_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_ords_uid', filt_clause: 'equals', filt_value: model.ords_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_ords_uid', filt_clause: 'equals', filt_value: model.ords_uid }]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_ords_uid', filt_clause: 'equals', filt_value: model.ords_uid }]}
			/>
		)
	}
];

export default tabs;
